import { Injectable } from "@angular/core";
import { GlobalConstants } from "../../constants";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class LoginServiceService {
  private baseURL =
    GlobalConstants.BASE_API_URL + ":" + GlobalConstants.BASE_API_URL_PORT;

  constructor(private httpClient: HttpClient) {}

  validateUser(user, password) {
    const url = `${this.baseURL}/user/api/validate`;
    return this.httpClient.post(url, { user: user, password: password });
  }

  validateB2BUser(user, password) {
    const url = `${this.baseURL}/user/api/validate/b2b`;
    return this.httpClient.post(url, { user: user, password: password });
  }
}
